import { ReactElement } from 'react'
import { StyledReview } from './styles'
import { ReviewProps } from './props'
import { Stars, Text } from '../..'
import { Flex, Grid } from '..'

const Review = ({
    comment,
    date,
    name,
    rating,
    ...props
}: ReviewProps): ReactElement => (
    <StyledReview {...props}>
        <Grid gap="4">
            <Flex justifyContent="space-between">
                <Text primary bold>
                    {name}
                </Text>
                <Text>{date}</Text>
            </Flex>
            <Stars rating={rating} size="m" />
            <Text>{comment}</Text>
        </Grid>
    </StyledReview>
)

export default Review

export { StyledReview }
